// extracted by mini-css-extract-plugin
export default {"container":"dashBoardPage_container__uB5DU","settingsContainer":"dashBoardPage_settingsContainer__9pwnY"};